import { render, staticRenderFns } from "./TestEData.vue?vue&type=template&id=0aa7cf74&scoped=true"
import script from "./TestEData.vue?vue&type=script&lang=js"
export * from "./TestEData.vue?vue&type=script&lang=js"
import style0 from "./TestEData.vue?vue&type=style&index=0&id=0aa7cf74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa7cf74",
  null
  
)

export default component.exports